{
  "loading": "A carregar...",
  "placeholder": "Selecionar uma opção..."
}
